export default class AuthError extends Error {
  constructor(message = 'Authorization error') {
    super(message);
    this.name = 'AuthError';
  }
}
